import { Role } from './role.model';
import firebase from 'firebase/compat/app';

export interface User extends firebase.User {
  id: string;
  roles?: Role;
  companyId: string;
}

export class User implements User  {
  id: string;
  name: string;
  displayName: string;
  email: string;
  photoURL: string;
  roles?: Role;
  uid: string;
  companyId: string;
  emailVerified: boolean;
  image: any;
  isEditable: boolean;
  phone: string;
  siteId: string;
  facebook?: string;
  twitter?: string;
  linkedIn?: string;
  instagram?: string;
  url?: string;
  profile!: UserProfile;
  work!: UserWork;
  contacts!: UserContacts;
  social!: UserSocial;
  settings!: UserSettings;
  message: string;
  billingAddress?: BillingAddress;
  shippingAddress?: ShippingAddress;
  companyDiscounts?: any;

}

export class BillingAddress {
  firstName = '';
  middleName = '';
  lastName = '';
  company = '';
  email = '';
  phone = '';
  country = '';
  city = '';
  place = '';
  postalCode = '';
  address = '';
}

export class ShippingAddress {
  firstName = '';
  middleName = '';
  lastName = '';
  company = '';
  email = '';
  phone = '';
  country = '';
  city = '';
  place = '';
  postalCode = '';
  address = '';
}


export class UserProfile {
  name = '';
  surname = '';
  birthday!: Date;
  gender = '';
  image = '';
}

export class UserWork {
  company = '';
  position = '';
  salary = 0;
}

export class UserContacts{
  email = '';
  phone = '';
  address = '';
}

export class UserSocial {
  facebook = '';
  twitter = '';
  google = '';
}

export class UserSettings{
  isActive = false;
  isDeleted = false;
  registrationDate!: Date;
  joinedDate!: Date;
}
